import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { DND_ITEM_TYPE_QUESTION, getColor } from '@lib/common';
import { useCallback, useRef } from 'react';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';
import { useSidebarLiveDrag } from '../sidebar-live-drag.context';
import { jsx as _jsx } from "react/jsx-runtime";
var DropShell = styled.div.withConfig({
  displayName: "section-drop-targetcomponent__DropShell",
  componentId: "sc-1k9hf3a-0"
})(["border-radius:12px;outline:", ";background-color:", ";transition:outline-color 0.15s ease,background-color 0.15s ease;"], function (_ref) {
  var $isOver = _ref.$isOver,
      $canDrop = _ref.$canDrop;
  return $isOver && $canDrop ? "2px solid ".concat(getColor('fillIntActive')) : '2px solid transparent';
}, function (_ref2) {
  var $isOver = _ref2.$isOver,
      $canDrop = _ref2.$canDrop;
  return $isOver && $canDrop ? 'rgba(239, 246, 255, 0.65)' : 'transparent';
});
/**
 * Section-level drop target. Child question rows handle precise insert indices;
 * this catches drops on the section header / padding and appends to the section.
 * Also drives live cross-section preview when hovering the header.
 */

export var SectionDropTarget = function SectionDropTarget(_ref3) {
  var sectionId = _ref3.sectionId,
      appendIndex = _ref3.appendIndex,
      disabled = _ref3.disabled,
      _onDropQuestion = _ref3.onDropQuestion,
      children = _ref3.children;

  var _useSidebarLiveDrag = useSidebarLiveDrag(),
      previewInSection = _useSidebarLiveDrag.previewInSection,
      commitCrossSectionMove = _useSidebarLiveDrag.commitCrossSectionMove;

  var sectionIdRef = useRef(sectionId);
  var appendIndexRef = useRef(appendIndex);
  var previewInSectionRef = useRef(previewInSection);
  var commitRef = useRef(commitCrossSectionMove);
  sectionIdRef.current = sectionId;
  appendIndexRef.current = appendIndex;
  previewInSectionRef.current = previewInSection;
  commitRef.current = commitCrossSectionMove;
  var handleDrop = useCallback(function (item) {
    var targetSectionId = sectionIdRef.current;
    var sourceSectionId = item.originalSectionId;

    if (!targetSectionId || !sourceSectionId || sourceSectionId === targetSectionId) {
      return {
        dropped: false
      };
    }

    var targetIndex = item.sectionId === targetSectionId ? item.index : appendIndexRef.current;
    commitRef.current({
      questionId: item.id,
      targetSectionId: targetSectionId,
      targetIndex: targetIndex,
      sourceSectionId: sourceSectionId
    });
    return {
      dropped: true,
      crossSection: true,
      targetSectionId: targetSectionId,
      targetIndex: targetIndex
    };
  }, []);

  var _useDrop = useDrop(function () {
    return {
      accept: DND_ITEM_TYPE_QUESTION,
      canDrop: function canDrop(item) {
        if (disabled) {
          return false;
        }

        var sourceSectionId = item.originalSectionId;
        return Boolean(sourceSectionId) && sourceSectionId !== sectionIdRef.current;
      },
      hover: function hover(item, monitor) {
        if (disabled) return;
        if (!monitor.isOver({
          shallow: true
        })) return;
        var targetSectionId = sectionIdRef.current;
        var sourceSectionId = item.originalSectionId;
        if (!sourceSectionId || sourceSectionId === targetSectionId) return;
        var nextIndex = appendIndexRef.current;
        previewInSectionRef.current(targetSectionId, nextIndex);
        item.sectionId = targetSectionId;
        item.index = nextIndex;
      },
      drop: function drop(item, monitor) {
        // Child question/heading rows already handled a precise insert.
        if (monitor.didDrop()) {
          return;
        }

        return handleDrop(item);
      },
      collect: function collect(monitor) {
        return {
          // shallow: only highlight when over the shell, not a nested question row
          isOver: monitor.isOver({
            shallow: true
          }),
          canDrop: monitor.canDrop()
        };
      }
    };
  }, [disabled, handleDrop]),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOver = _useDrop2$.isOver,
      canDrop = _useDrop2$.canDrop,
      drop = _useDrop2[1];

  return /*#__PURE__*/_jsx(DropShell, {
    ref: drop,
    $isOver: isOver,
    $canDrop: canDrop,
    children: children
  });
};